import React from "react"
import styled from "styled-components"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import ShopCard from "./ShopCard"
import Faqs from '../faqs/Faqs';

const BuySection = styled(BackgroundImage)`
  padding: 3rem 0;
`

function Buy() {
  const { background } = useStaticQuery(graphql`
    query {
      background: file(relativePath: { eq: "back-buy.png" }) {
        sharp: childImageSharp {
          fluid(quality: 80, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <BuySection
      tag="section"
      fluid={background.sharp.fluid}
      fadeIn="soft"
      backgroundColor={`#1a1a1a`}
    >
      <Container>
        <Row>
          <Col lg={6}>
              <ShopCard />
          </Col>
          <Col lg={6} className="p-2">
              <Faqs />
          </Col>
        </Row>
      </Container>
    </BuySection>
  )
}

export default Buy
